import { forwardRef } from "react";
import clsx from "clsx";

import "./FreeTrialCard.css";
import {
  getDateWithDaysOffset,
  getMonthDayYearDateString,
  getPeriodString,
} from "../../lib/helpers/dateHelper";
import { PaymentData } from "../../lib/types";

type Props = {
  freeTrialActive: boolean;
  freeDays: number;
  paymentData: PaymentData;
};
const FreeTrialCard = forwardRef<HTMLDivElement, Props>(
  ({ freeTrialActive, freeDays, paymentData }, ref) => {
    const now = new Date();
    return (
      <div className="FreeTrialCardWrapper">
        <div className="card" ref={ref}>
          <div>
            <h3 className={clsx("cardHeader", "semibold")}>
              {freeTrialActive ? `Your ${freeDays}-day Free Trial` : "Your Plan"}
            </h3>
            {freeTrialActive && (
              <p className={clsx("cardCaption", "body-sm")}>
                Cancel your trial anytime before{" "}
                {getMonthDayYearDateString(getDateWithDaysOffset(now, freeDays))}
                {" "}if you choose not to continue with the program.
              </p>
            )}
          </div>

          <div
            className={
              freeTrialActive ? "priceCard" : "priceCardNoTrial"
            }
          >
            {freeTrialActive && (
              <dl>
                <dt className="body-md semibold"> Price Today </dt>
                <dd className="body-md semibold"> FREE </dd>
              </dl>
            )}

            <dl>
              <dt className="body-md">
                <span>
                  {freeTrialActive
                    ? "After Trial"
                    : `${getPeriodString(paymentData.period)?.adjective} Plan`}
                </span>
              </dt>
              <dd className="body-md">
                $13/mo billed yearly
              </dd>
            </dl>
          </div>
        </div>
      </div>
    );
  }
);

export default FreeTrialCard;
